import { Table, Space, Switch, Checkbox } from "antd";
import Main from "../components/layout/Main";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  UserAddOutlined,
  UserOutlined,
  ArrowLeftOutlined,
  EditOutlined,
  FolderOpenOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import Header from "../components/layout/Header";
import { Modal } from "antd";
import { useState, useEffect } from "react";
import { get, put, post, remove } from "../Libraries/Ajax/HttpService";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import back from "../assets/images/back.svg";
import deleteIcon from "../assets/images/delete.svg";
import edit from "../assets/images/edit.svg";
import { Progress } from "antd";
import { useDistrict } from "../utils/DistrictContext";
import zxcvbn from "zxcvbn";
function Listregistereduser() {
  var mcdata = JSON.parse(localStorage.getItem("MCData"));
  const [loading, setloading] = useState(true);
  const [open, setOpen] = useState(false);
  const [opens, setOpens] = useState(false);
  const [reset, setReset] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState("");
  const [modalType, setModalType] = useState("");
  const [modalFrequency, setModalFrequency] = useState("");
  const [modalStatus, setModalStatus] = useState("");
  const [modalDistrict, setModalDistrict] = useState([]);
  const [modalId, setModalId] = useState("");
  const [selected, setSelected] = useState("SA");
  const [password, setPassword] = useState("");
  const [score, setScore] = useState("");
  const [feedback, setfeedback] = useState("");
  const [passwordconfirm, setPasswordconfirm] = useState("");
  const [confirm_feedback, setConfirm_feedback] = useState("");
  const [datas, setDatas] = useState("");
  const [selectedDistricts, setSelectedDistricts] = useState([]);
  const { selectedDistrict } = useDistrict();
  const columns = [
    {
      title: "First Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Last Name",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Email ID",
      dataIndex: "frequency",
      key: "frequency",
    },
    {
      title: "User Type",
      dataIndex: "selected",
      key: "selected",
      render: (_, record) =>
        record.selected === "SA"
          ? "Super Admin"
          : record.selected === "A"
          ? "Admin"
          : "User",
    },

    {
      title: "Status",
      dataIndex: "active",
      key: "active",
      render: (_, record) => (record.active === true ? "Active" : "Inactive"),
    },

    {
      title: "Edit",
      align: "center",
      dataIndex: "action",
      key: "id",
      onCell: (record) => {
        return {
          onClick: (ev) => {
            record.selected === "SA"
              ? handledummyedit()
              : onEditClick(
                  record.id,
                  record.name,
                  record.type,
                  record.frequency,
                  record.active,
                  record.selected,
                  record.selectedDistricts
                );
          },
        };
      },
      render: (_, record) => (
        <>
          {" "}
          {record.selected === "SA" ? (
            ""
          ) : (
            <Space>
              {/* <EditOutlined style={{ fontSize: '30px', color: '#08c', marginRight: '1rem' }}

          /> */}
              <img
                src={edit}
                alt="Edit"
                style={{ width: "25px", verticalAlign: "middle" }}
              />
            </Space>
          )}
        </>
      ),
    },
    {
      title: "Delete",
      dataIndex: "actions",
      align: "center",
      key: "id",
      onCell: (record) => {
        return {
          onClick: (ev) => {
            record.selected === "SA"
              ? handledummydelete()
              : modaldel(record.id);
          },
        };
      },
      render: (_, record) => (
        <>
          {" "}
          {record.selected === "SA" ? (
            ""
          ) : (
            <Space>
              {/* <DeleteOutlined style={{ fontSize: '30px', color: '#F74257' }}

            /> */}
              <img
                src={deleteIcon}
                alt="delete"
                style={{ width: "25px", verticalAlign: "middle" }}
              />
            </Space>
          )}
        </>
      ),
    },
  ];

  const showModal = () => {
    setOpen(true);
  };

  const handleCheckboxChange = (value) => {
    setModalDistrict((prev) => {
      let arr = prev
        ? prev
            .split(",")
            .map((d) => d.trim())
            .filter(Boolean)
        : [];

      if (arr.includes(value)) {
        arr = arr.filter((d) => d !== value);
      } else {
        arr.push(value);
      }

      const updated = arr.join(",");
      console.log("Updated districts:", updated);
      return updated;
    });
  };

  const parseDistrictString = (districts) => {
    if (!districts) return "";
    if (Array.isArray(districts)) return districts.join(",");
    return String(districts).replace(/[{}]/g, "").trim();
  };

  const getCustomScore = (temp_password, zxcvbnScore) => {
    let score = zxcvbnScore;
    console.log("score xvb ", score);
    // Enforce minimum length
    if (temp_password.length < 8) {
      score = 0;
      console.log("score is ", score);
      return score;
    }
    // Enforce at least one capital letter, one number, and one special character
    const hasCapitalLetter = /[A-Z]/.test(temp_password);
    const hasNumber = /[0-9]/.test(temp_password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(temp_password);

    if (!hasCapitalLetter || !hasNumber || !hasSpecialChar) {
      score = Math.min(score, 2); // Lower the score if the requirements are not met
      console.log("score is sss", score);
      score = 1;
    }

    if (
      hasCapitalLetter &&
      hasNumber &&
      hasSpecialChar &&
      temp_password.length > 8
    ) {
      score = 2;
      if (temp_password.length > 12) {
        score = 3;
      }
      if (temp_password.length > 21) {
        score = 4;
      }
    }
    console.log("score is ", score);

    return score;
  };

  const getFeedback = (temp_password) => {
    const feed =
      "Password must be at least 8 characters long, at least one capital letter ,one number,one special character and must not contain spaces.";
    if (temp_password.length < 1) {
      return "";
    } else {
      return feed;
    }

    return "";
  };

  const handlePasswordChange = (e) => {
    const temp_password = e.target.value;
    const hasWhitespace = /\s/.test(temp_password);

    if (temp_password.length <= 32 && !hasWhitespace) {
      const result = zxcvbn(temp_password);
      const customScore = getCustomScore(temp_password, result.score);
      const feedback = getFeedback(temp_password);

      setPassword(temp_password);
      setScore(customScore);
      setfeedback(feedback);
    } else if (hasWhitespace) {
      setfeedback("Password should not contain spaces.");
    } else {
      setfeedback("Password exceeds the maximum length of 32 characters.");
    }
  };

  const handleOks = () => {
    const url = `apis/delete_user/${modalId}`;
    remove(url).then((res) => {
      console.log(res);
      setConfirmLoading(true);
      toast.success(res.data.message);
      setTimeout(() => {
        setOpen(false);
        setConfirmLoading(false);
      }, 2000);
    });

    setTimeout(() => {
      // history.go(0);
      window.location.reload();
    }, 3000);
  };

  const getColor = () => {
    switch (score) {
      case 0:
        return "gray";
      case 1:
        return "red";
      case 2:
        return "orange";
      case 3:
        return "green";
      case 4:
        return "green";
      default:
        return "gray";
    }
  };

  const handleConfirmChange = (e) => {
    const confirm_pass = e.target.value;
    if (confirm_pass == password) {
      setConfirm_feedback("");
      setPasswordconfirm(confirm_pass);
      setfeedback("");
    } else {
      let msg = "";
      if (passwordconfirm && passwordconfirm.length > 1) {
        msg = "Password is not matching.";
      }
      setConfirm_feedback(msg);
      setPasswordconfirm(confirm_pass);
    }
  };

  const handleOk = () => {
    const params = JSON.stringify({
      first_name: modalText,
      last_name: modalType,
      email: modalFrequency,
      active: modalStatus,
      user_type: selected,
      districts: modalDistrict,
    });
    const url = `apis/signup/edit/${modalId}`;
    put(url, params)
      .then((response) => {
        console.log(response);
        // setConfirmLoading(true);
        // setTimeout(() => {
        setOpen(false);
        toast.success(response.data.message);
        // history.go(0);
        window.location.reload();
        // }, 1000);
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
    // setConfirmLoading(false);
  };
  const handleCancel = () => {
    console.log("Clicked cancel button");
    setOpen(false);
  };
  const handleCancels = () => {
    console.log("Clicked cancel button");
    setOpens(false);
  };

  const handleOkss = () => {
    if (password == passwordconfirm && score >= 2) {
      const params = JSON.stringify({
        new_password: password,
        confirm_password: passwordconfirm,
        email: modalFrequency,
      });
      const url = `apis/admin_change_password`;
      post(url, params)
        .then((response) => {
          console.log(response);
          setReset(false);
          // setConfirmLoading(true);
          setTimeout(() => {
            toast.success(response.data.message);
          }, 1000);
          //  history.go(0);
        })
        .catch((error) => {
          toast.error(error.response.data.msg);
        });
      // setConfirmLoading(false);
    } else {
      toast.error(
        "Please complete all required fields before submitting the form.",
        {
          autoClose: 3000,
        }
      );
    }
  };

  const handleCancelss = () => {
    console.log("Clicked cancel button");
    setReset(false);
  };

  const onEditClick = (id, name, type, frequency, active, user, districts) => {
    console.log("districts from API", districts);

    setOpen(true);
    setModalId(id);
    setModalText(name);
    setModalType(type);
    setModalFrequency(frequency);
    setModalStatus(active);
    setSelected(user);
    setModalDistrict(parseDistrictString(districts));
  };
  const handledummyedit = () => {
    setOpen(false);
  };
  const handledummydelete = () => {
    setOpens(false);
  };

  useEffect(() => {
    getData();
  }, [selectedDistrict]);

  const getData = async () => {
    get("apis/user_list").then((res) => {
      setloading(false);
      console.log("userlist", res.data.data.Users);
      setDatas(
        res.data.data.Users.map((row) => ({
          name: row.first_name,
          frequency: row.email,
          type: row.last_name,
          active: row.is_active,
          id: row.id,
          selected: row.type_name,
          selectedDistricts: row.districts || [], // Provide a default empty array if districts is undefined
        }))
      );

      console.log("jfjgh", datas);
    });
  };

  const { Column, ColumnGroup } = Table;
  const modalclick = () => {
    setOpen(true);
  };
  const modaldel = (id) => {
    setOpens(true);
    setModalId(id);
  };
  const getReset = (e) => {
    // history.push('/reset');

    setReset(true);
    setOpen(false);
  };
  const onActiveChange = (checked) => {
    setModalStatus(checked);
  };

  const onselectClickss = () => {
    // history.push('/dashboard');
    // window.history.back();
    navigate(-1);
  };
  const onMouseClickpath = (event) => {
    navigate("/registration");
  };
  const onselectClick = () => {
    navigate("/settingsuser");
  };
  const onselectMetermangement = () => {
    navigate("/metermanagement");
  };
  const onselectClicks = () => {
    navigate("/list");
  };

  const onselectMeterHistory = () => {
    navigate("/meterhistory");
  };

  const onselectClickaccount = () => {
    navigate("/accountnames");
  };
  const onMouseClick = (event) => {
    setSelected(event.target.value);
  };
  const navigate = useNavigate();
  const onFinish = (values) => {
    console.log(values);
  };
  const paginationConfig = {
    defaultPageSize: 20, // Set your default pagination size here
    pageSizeOptions: ["10", "20", "30"], // Optional: Specify additional page size options
  };
  return (
    <>
      {/* <head>
        <title> {window.location.href.indexOf("mizuwatch.com") > -1?"MizuWatch":"MizuSmart"}  </title></head> */}
      <Header />
      <Main>
        <div>
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <div className="d-flex ">
              <img
                src={back}
                alt=""
                style={{ width: "10px", cursor: "pointer" }}
                onClick={onselectClickss}
              />
              {/* <ArrowLeftOutlined onClick={onselectClickss} /> */}
              {/* <h3 className="mb-0">User Listing</h3> */}
              <div className="d-flex align-items-center">
                {mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? (
                  ""
                ) : (
                  <>
                    <div
                      className="new-box-padding   align-self-center c-pointer "
                      onClick={onselectClick}
                      style={{ borderBottom: "2px solid #ccc" }}
                    >
                      {" "}
                      Settings
                    </div>
                    <div
                      className=""
                      style={{
                        width: "2px",
                        height: "25px",
                        background: "#ccc",
                      }}
                    ></div>
                  </>
                )}
                {mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? (
                  ""
                ) : (
                  <>
                    <div
                      className="new-box-padding  text-blue  align-self-center c-pointer "
                      onClick={onselectClicks}
                      style={{
                        borderBottom: "2px solid #1998f0",
                        borderRadius: "0",
                      }}
                    >
                      Users
                    </div>
                  </>
                )}

                {/* { mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? "" :<><div className=""  style={{width: '2px', height: '25px', background: '#ccc' }}></div>
              <div className="new-box-padding   align-self-center c-pointer "
              style={{borderBottom: '2px solid #ccc'}} onClick={onMouseClickpath}>User Registration</div></>} */}

                <div
                  className=""
                  style={{ width: "2px", height: "25px", background: "#ccc" }}
                ></div>
                <div
                  className="new-box-padding   align-self-center c-pointer "
                  onClick={onselectClickaccount}
                  style={{ borderBottom: "2px solid #ccc" }}
                >
                  {" "}
                  Accounts
                </div>

                {/* {mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? (
                  ""
                ) : (
                  <>
                    <div
                      className=""
                      style={{
                        width: "2px",
                        height: "25px",
                        background: "#ccc",
                      }}
                    ></div>
                    <div
                      className="new-box-padding   align-self-center c-pointer "
                      onClick={onselectMetermangement}
                      style={{
                        borderBottom: "2px solid #ccc",
                      }}
                    >
                      {" "}
                      Meter Management
                    </div>
                  </>
                )} */}

                {/* {mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? (
                  ""
                ) : (
                  <>
                    <div
                      className=""
                      style={{
                        width: "2px",
                        height: "25px",
                        background: "#ccc",
                      }}
                    ></div>
                    <div
                      className="new-box-padding   align-self-center c-pointer "
                      onClick={onselectMeterHistory}
                      style={{
                        borderBottom: "2px solid #ccc",
                      }}
                    >
                      {" "}
                      Meter History
                    </div>
                  </>
                )} */}
                {mcdata.mcdatas.type === "U" || selectedDistrict === "FB151" ? (
                  ""
                ) : (
                  <>
                    {/* <div
                      style={{
                        width: "2px",
                        height: "25px",
                        background: "#ccc",
                      }}
                    ></div>
                    <div
                      className="new-box-padding align-self-center c-pointer"
                      onClick={onselectMetermangement}
                      style={{ borderBottom: "2px solid #ccc" }}
                    >
                      Meter Management
                    </div> */}
                  </>
                )}

                {mcdata.mcdatas.type === "U" || selectedDistrict === "FB151" ? (
                  ""
                ) : (
                  <>
                    {/* <div
                      style={{
                        width: "2px",
                        height: "25px",
                        background: "#ccc",
                      }}
                    ></div>
                    <div
                      className="new-box-padding align-self-center c-pointer"
                      onClick={onselectMeterHistory}
                      style={{ borderBottom: "2px solid #ccc" }}
                    >
                      Meter History
                    </div> */}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className="new-box-padding bg-white border rounded d-flex text-blue  align-items-center c-pointer"
          onClick={onMouseClickpath}
          style={{
            width: "210px",
            marginLeft: "auto",
            justifyContent: "center",
            fontSize: "18px",
          }}
        >
          {" "}
          User Registration
        </div>
        {/* no data found */}

        {/* no data found */}
        <h4 class="text-blue mt-5 fw-bold mb-4 px-2">Existing Users</h4>
        {datas.length > 0 ? (
          <Table
            columns={columns}
            dataSource={datas}
            className="settingsTable mt-4"
            // pagination={paginationConfig}
            pagination={false}
          />
        ) : (
          <div className="no-found">
            <div>
              <FolderOpenOutlined />
              <span className="found-text">No data Found</span>
            </div>
          </div>
        )}

        {open === true ? (
          <Modal
            // title="Override Name"
            open={open}
            onOk={handleOk}
            confirmLoading={confirmLoading}
            onCancel={handleCancel}
            centered="true"
            okText="Update"
          >
            <form class="form-horizontal bg-white mx-auto p-3 login-form">
              <div class="forms-inputs mt-3">
                <span for="pwd">First Name</span>
                <input
                  type="text"
                  class="form-control"
                  id="pwd"
                  placeholder="Edit First Name"
                  defaultValue={modalText}
                  onChange={(e) => {
                    setModalText(e.target.value);
                  }}
                />
              </div>
              <div class="forms-inputs">
                <span for="pwd">Last Name</span>
                <input
                  type="text"
                  class="form-control"
                  id="pwd"
                  placeholder="Edit Last Name"
                  defaultValue={modalType}
                  onChange={(e) => {
                    setModalType(e.target.value);
                  }}
                />
              </div>
              <div class="forms-inputs">
                <span for="email">Email</span>
                <input
                  type="text"
                  class="form-control"
                  id="email"
                  placeholder="Edit EmailID"
                  defaultValue={modalFrequency}
                  onChange={(e) => {
                    setModalFrequency(e.target.value);
                  }}
                />
              </div>
              {JSON.parse(localStorage.getItem("MCData")).mcdatas
                ?.all_user_creation === true ? (
                <>
                  <select
                    name="All meters"
                    id="selector"
                    className="box w-100"
                    style={{ height: "45px", fontWeight: 400 }}
                    onChange={onMouseClick}
                    placeholder="Please Select User Type"
                  >
                    <option value="" disabled selected>
                      Select User Type
                    </option>
                    <option
                      value="SA"
                      selected={selected === "SA" ? true : false}
                    >
                      Super Admin
                    </option>
                    <option
                      value="A"
                      selected={selected === "A" ? true : false}
                    >
                      Admin{" "}
                    </option>
                    <option
                      value="U"
                      selected={selected === "U" ? true : false}
                    >
                      User
                    </option>
                  </select>
                </>
              ) : (
                <>
                  <select
                    name="All meters"
                    id="selector"
                    className="box w-100"
                    style={{ height: "45px", fontWeight: 400 }}
                    onChange={onMouseClick}
                    placeholder="Please Select User Type"
                  >
                    <option value="" disabled selected>
                      Select User Type
                    </option>

                    <option
                      value="U"
                      selected={selected === "U" ? true : false}
                    >
                      User
                    </option>
                  </select>
                </>
              )}

              <div class="col-md-4 mt-5">
                <h6
                  className="w-100  total-flow-font-size"
                  style={{ color: "#515252" }}
                >
                  <b>District Selection</b>
                </h6>
                <div class="form-check ps-0 d-flex align-items-center mt-3">
                  {mcdata?.district?.map((d) => (
                    <Checkbox
                      key={d.id}
                      value={d.district_name}
                      onChange={() => handleCheckboxChange(d.district_name)}
                      checked={modalDistrict.includes(d.district_name)}
                    >
                      <span
                        className="ms-2"
                        style={{ color: "#515252", whiteSpace: "nowrap" }}
                      >
                        <b>{d.district_display_name}</b>
                      </span>
                    </Checkbox>
                  ))}
                  <br />
                </div>
              </div>
              <div class="checkbox">
                <br />
                <span for="status">Status</span>
                <br />
                <Switch
                  defaultChecked={modalStatus}
                  onChange={onActiveChange}
                />
                <div class="float-right text-blue">
                  <Link onClick={getReset}>Password Reset</Link>
                </div>
              </div>
            </form>
          </Modal>
        ) : (
          ""
        )}
        {opens === true ? (
          <Modal
            open={opens}
            onOk={handleOks}
            confirmLoading={confirmLoading}
            onCancel={handleCancels}
            centered="true"
          >
            <h5 className="text-left pt-4">
              Are you sure you want to permanently remove this item?
            </h5>
          </Modal>
        ) : (
          ""
        )}
        {reset === true ? (
          <Modal
            // title="Override Name"
            open={reset}
            onOk={handleOkss}
            confirmLoading={confirmLoading}
            onCancel={handleCancelss}
            centered="true"
            okText="Update"
          >
            <form class="form-horizontal bg-white mx-auto p-3 login-form">
              <div class="forms-inputs mt-3">
                <span for="pwd">Password</span>
                <input
                  type="password"
                  class="form-control"
                  id="pwd"
                  value={password}
                  placeholder="Enter Password"
                  onChange={handlePasswordChange}
                />
                {password.length > 0 && (
                  <>
                    <Progress
                      percent={(score + 1) * 10}
                      strokeColor={getColor()}
                      showInfo={false}
                      style={{ marginTop: "10px" }}
                    />
                    <div style={{ textAlign: "center", marginTop: "10px" }}>
                      {password != passwordconfirm &&
                        [
                          "Strength :  Very Weak",
                          "Strength : Weak",
                          "Strength : Good",
                          "Strong",
                          "Very Strong",
                        ][score]}
                    </div>
                    <div style={{ color: "red", marginTop: "10px" }}>
                      <p>Password Requirements:</p>
                      <ul>
                        <li>Minimum Length: 8 characters</li>
                        <li>
                          Uppercase Letter: At least one uppercase letter (A-Z)
                        </li>
                        <li>Number: At least one number (0-9)</li>
                        <li>
                          Special Character: At least one special character
                          (e.g., @, #, $, etc.)
                        </li>
                        <li>No Spaces: Password must not contain spaces</li>
                      </ul>
                    </div>
                  </>
                )}
              </div>
              <div class="forms-inputs">
                <span for="pwd">Confirm Password</span>
                <input
                  type="password"
                  class="form-control"
                  id="pwd"
                  placeholder="Please Confirm Password"
                  onChange={handleConfirmChange}
                />
                {confirm_feedback && (
                  <div
                    style={{
                      color: "red",
                      textAlign: "center",
                      marginTop: "10px",
                    }}
                  >
                    {confirm_feedback}
                  </div>
                )}
              </div>
            </form>
          </Modal>
        ) : (
          ""
        )}
      </Main>
    </>
  );
}
export default Listregistereduser;
